var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-stat',{attrs:{"value":_vm.value,"subvalue":_vm.subvalue,"text":_vm.field.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }